<div class="flex items-center">
	<div *ngIf="logoUrl" [class]="imageWrapperClass">
		<img [src]="'/assets/images/banks/' + logoUrl" />
	</div>
	<span *ngIf="showName">{{ name }}</span>
	<span *ngIf="showShortName">{{ shortName }}</span>
</div>
